// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubtitleTemplate_O3UnX {
  color: #676767;
  font-size: clamp(17px, 5vw, 20px) !important;
  font-weight: 300;
  text-align: center;
  margin: 0 auto;
  max-width: 680px;
  span{
    font-weight: 800;
  }

  p {
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SubtitleTemplate/SubtitleTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".SubtitleTemplate {\n  color: #676767;\n  font-size: clamp(17px, 5vw, 20px) !important;\n  font-weight: 300;\n  text-align: center;\n  margin: 0 auto;\n  max-width: 680px;\n  span{\n    font-weight: 800;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SubtitleTemplate": `SubtitleTemplate_O3UnX`
};
export default ___CSS_LOADER_EXPORT___;
